import { useEffect } from "react";
import Lenis from "lenis";
import { toast } from "../components/ui/sonner";
import { Nav } from "../landing/Nav";
import { Hero } from "../landing/Hero";
import { TrustMarquee } from "../landing/TrustMarquee";
import { Manifesto } from "../landing/Manifesto";
import { DualEngine } from "../landing/DualEngine";
import { BuyDVR } from "../landing/BuyDVR";
import { Calculator } from "../landing/Calculator";
import { Onboarding } from "../landing/Onboarding";
import { WhyWePay } from "../landing/WhyWePay";
import { Privacy } from "../landing/Privacy";
import { Faq } from "../landing/Faq";
import { Footer } from "../landing/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    function loop(time) {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    }
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const handleDownload = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.geonetix.live&hl=en_IN",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const handleBuy = () => {
    toast("Car DVR store opening soon", {
      description: "GeoNetix-approved dashcams will be available to order shortly. Stay tuned!",
      duration: 4000,
    });
  };

  return (
    <div className="bg-[#0A192F] text-slate-100 antialiased selection:bg-[#4CAF50] selection:text-[#04140a]">
      <Nav onDownload={handleDownload} onBuy={handleBuy} />
      <main>
        <Hero onDownload={handleDownload} />
        <TrustMarquee />
        <DualEngine />
        <Calculator />
        <Onboarding />
        <WhyWePay />
        <Manifesto />
        <BuyDVR onBuy={handleBuy} />
        <Privacy />
        <Faq />
      </main>
      <Footer onDownload={handleDownload} />
    </div>
  );
}
